/**
 * Component mapping constants for the WLC Cancel Modal
 * Centralizes routing logic for different cancellation reasons
 */

import { CANCEL_MODAL_STEPS } from './steps';

// Maps cancellation reasons to their corresponding pause offer components
export const PAUSE_OFFER_COMPONENTS = {
  tooBusy: 'PauseOffer',
  notUsing: 'NotUsingPauseOffer',
  technicalIssues: 'TechnicalIssuesPauseOffer'
};

// Maps cancellation reasons to their corresponding downgrade offer components
export const DOWNGRADE_OFFER_COMPONENTS = {
  tooExpensive: 'CostDowngradeOffer',
  goalAchieved: 'GoalAchievedDowngradeOffer'
};

// Maps cancellation reasons to their corresponding pause confirmation components
export const PAUSE_CONFIRMATION_COMPONENTS = {
  technicalIssues: 'TechnicalIssuesPauseConfirmation',
  default: 'BillingPauseConfirmation'
};

// Maps cancellation reasons to the appropriate next step
export const REASON_TO_STEP_MAPPING = {
  tooBusy: CANCEL_MODAL_STEPS.PAUSE_OFFER,
  notUsing: CANCEL_MODAL_STEPS.PAUSE_OFFER,
  technicalIssues: CANCEL_MODAL_STEPS.PAUSE_OFFER,
  tooExpensive: CANCEL_MODAL_STEPS.DOWNGRADE_OFFER,
  goalAchieved: CANCEL_MODAL_STEPS.DOWNGRADE_OFFER,
  other: CANCEL_MODAL_STEPS.NEXT_ACTION
};

// Defines which reasons get pause offers
export const PAUSE_OFFER_REASONS = ['tooBusy', 'notUsing', 'technicalIssues'];

// Defines which reasons get downgrade offers
export const DOWNGRADE_OFFER_REASONS = ['tooExpensive', 'goalAchieved'];

// Helper function to determine if a reason gets a pause offer
export const isPauseOfferReason = reason => PAUSE_OFFER_REASONS.includes(reason);

// Helper function to determine if a reason gets a downgrade offer
export const isDowngradeOfferReason = reason => DOWNGRADE_OFFER_REASONS.includes(reason);

// Helper function to get the next step for a given reason
export const getNextStepForReason = reason => {
  return REASON_TO_STEP_MAPPING[reason] || CANCEL_MODAL_STEPS.NEXT_ACTION;
};
